import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import api from '@src/common/services/api.service';
import {Report} from '@src/views/reports/domain/reports.model';
import AppConstants from "@utils/app.constants";
import {ApplicationResponse, StateTrackedData} from "@common/domain/common.model";
import {UsersListModel} from "@views/users/domain/users.model";

export interface AddReportDetailsPayload {
    companyName: string;
    companyTagLine: string;
    companyAddress1: string;
    companyAddress2?: string;
    reportName: string;
    formatNo: number;
    revisionNo: number;
    createdBy?: string;
}

export interface ReportDetailsModelRef {
    id: string;
    companyName: string;
    companyTagLine: string;
    companyAddress1: string;
    companyAddress2?: string;
    reportName: string;
    formatNo: number;
    revisionNo: number;
    createdBy?: string;

}

// 1. Thunk action for adding report details
// export const addReportDetails = createAsyncThunk(
//     'reportDetails/addReportDetails',
//     async (reportData: AddReportDetailsPayload, {rejectWithValue}) => {
//         try {
//             const response = await api.post(
//                 `${AppConstants.api}/reports/template`
//                 , reportData);
//             return response.data;
//         } catch (error: any) {
//             return rejectWithValue(error.response?.data || error.message);
//         }
//     }
// );
function toFormData(obj: Record<string, any>): FormData {
    const formData = new FormData();
    Object.entries(obj).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
            formData.append(key, value as string | Blob);
        }
    });
    return formData;
}

export function convertToForm(payload: any, keys: string[]) {
    const formData = new FormData()
    keys.forEach(key => {
        const value = payload[key]
        if (value !== null && value !== undefined) {
            if (key === 'file' || Array.isArray(value)) {
                if (Array.isArray(value)) {
                    value.forEach((item, index) => {
                        const subKeys = Object.keys(item)
                        subKeys.forEach(subKey => {
                            formData.append(`${key}[${index}].${subKey}`, item[subKey])
                        })
                    })
                } else {
                    formData.append(key, value)
                }
            } else if (typeof value === 'string') {
                formData.append(key, value)
            } else {
                formData.append(key, JSON.stringify(value))
            }
        }
    })

    return formData
}

export const addReportDetails = createAsyncThunk(
    "reportDetails/addOrUpdateReportDetails",
    async (
        { reportData, isUpdate }: { reportData: AddReportDetailsPayload & { id?: string }, isUpdate?: boolean },
        { rejectWithValue }
    ) => {

        try {
            const formData = convertToForm(reportData, Object.keys(reportData));
            let response;
            if (isUpdate && reportData.id) {
                // PUT for update
                response = await api.put<ApplicationResponse<any>>(
                    `${AppConstants.api}/report/template`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                    // { headers: {'Content-Type': 'multipart/form-data'}}
                );
            } else {
                // POST for create
                response = await api.post<ApplicationResponse<any>>(
                    `${AppConstants.api}/report/template`,
                    formData,
                    {headers: {
                            "Content-Type": "multipart/form-data"
                        }}
                    // { headers: {'Content-Type': 'multipart/form-data'}}

                );
            }
            return response.data.data;
        } catch (err) {
            console.error("Add/Update Report Details Error:", err);
            return rejectWithValue("Failed to add/update report details");
        }
    }
);

export const getReportDetails = createAsyncThunk<ReportDetailsModelRef[], void>(
    'reportDetails/getReportDetails',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get<ApplicationResponse<ReportDetailsModelRef[]>>(`${AppConstants.api}/report/template`)
            console.log("Response",response)
            return response.data as unknown as ReportDetailsModelRef[];
        } catch (error: any) {
            return rejectWithValue(error.response?.data || error.message);
        }
    })

// 2. Add to your slice
const reportDetailsSlice = createSlice({
    name: 'reportDetails',
    initialState: {
        data: [],
        status: "loading",
        error: null,
    } as StateTrackedData<any>,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getReportDetails.pending, (state) => {
                state.status = "loading";
                state.error = null;
                state.data = []
            })
            .addCase(getReportDetails.fulfilled, (state, action) => {
                state.status = "idle";
                state.data = action.payload;
                state.error = null
            })
            .addCase(getReportDetails.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload as string;
                state.data = []
            });
    },
});

export default reportDetailsSlice.reducer;
